import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpEventType, HttpRequest } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class FileDataService {

    _baseUrl = 'api/v1/files';

    constructor(private authHttp: HttpClient) {
    }

    uploadFile(file: File, progress: ((progress) => void)): Promise<IFileInfo> {
        return new Promise((resolve, reject) => {

            const formData = new FormData();
            formData.append('file', file);

            this.authHttp
                .request(new HttpRequest('POST',
                    this._baseUrl,
                    formData,
                    {
                        reportProgress: true,
                    }))
                .subscribe((result: any) => {
                    if (result.type === HttpEventType.UploadProgress) {
                        if (progress) {
                            progress(result);
                        }
                    } else if (result instanceof HttpResponse) {
                        resolve(result.body as IFileInfo);
                    }
                },
                (err) => {
                    reject(err);
                });
        });
    }

    downloadFile(id: string) {
        return this.authHttp.request(new HttpRequest('GET',
            this._baseUrl + '/' + id,
            {
                reportProgress: true,
                responseType: 'blob',
            }));
    }
}

export interface IFileInfo {
    fileId: string;
    fileName: string;
}
